const JWT_PARTS_COUNT = 3;
const JWT_PART_PATTERN = /^[A-Za-z0-9_-]+$/;
const USER_ID_CLAIM_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const decodeBase64Url = (value: string): string | null => {
  const normalized = value.replaceAll('-', '+').replaceAll('_', '/');
  const paddingLength = (4 - (normalized.length % 4)) % 4;

  try {
    return atob(`${normalized}${'='.repeat(paddingLength)}`);
  } catch {
    return null;
  }
};

export const isLikelyJwtToken = (token: string | undefined | null): token is string => {
  if (typeof token !== 'string') {
    return false;
  }

  const normalizedToken = token.trim();
  if (!normalizedToken) {
    return false;
  }

  const jwtParts = normalizedToken.split('.');
  if (jwtParts.length !== JWT_PARTS_COUNT) {
    return false;
  }

  if (!jwtParts.every((part) => part.length > 0 && JWT_PART_PATTERN.test(part))) {
    return false;
  }

  const payload = decodeBase64Url(jwtParts[1]);
  if (!payload) {
    return false;
  }

  try {
    const payloadData = JSON.parse(payload) as { i?: unknown };
    return typeof payloadData.i === 'string' && USER_ID_CLAIM_PATTERN.test(payloadData.i);
  } catch {
    return false;
  }
};
